import originalDayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isToday from 'dayjs/plugin/isToday';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
/**
 * Make sure to update ./@types/dayjs.dt.s plugins are added or removed
 */
originalDayjs.extend(customParseFormat);
originalDayjs.extend(isToday);
originalDayjs.extend(utc);
originalDayjs.extend(relativeTime);
originalDayjs.extend(timezone);
/**
 * Since the inferred type for originalDayjs does not include
 * the augmented methods and properties provided by the plugins,
 * we need to force-cast the type. This is an issue with the library
 * itself due to lack of consistency in type declarations.
 */
export const dayjs = originalDayjs;
//# sourceMappingURL=dayjs.js.map